module.exports = __webpack_public_path__ + "img/bg05.390ef568.png";